export const DEFAULT_SUBJECT_SLUG = 'marketing'
export const BRAND_NAME = 'MasterClass Executive'
export const BRAND_KEY = 'masterclass_executive'
